import { render, staticRenderFns } from "./segment-performance.page.vue?vue&type=template&id=4b12fc01&scoped=true"
import script from "./segment-performance.page.vue?vue&type=script&lang=ts"
export * from "./segment-performance.page.vue?vue&type=script&lang=ts"
import style0 from "./segment-performance.page.vue?vue&type=style&index=0&id=4b12fc01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b12fc01",
  null
  
)

export default component.exports